import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {ServicesSectionComponent} from './services-section.component'
import {ContentSectionModule} from '../../../../craft/content-section/content-section.module'
import {SliderModule} from '../../../../craft/slider/slider.module'
import {TranslocoModule} from '@ngneat/transloco'
import {RouterModule} from '@angular/router'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {ButtonModule} from '../../../../craft/button/button.module'
import {CardsModule} from '../../../../craft/cards/cards.module'

@NgModule({
  declarations: [ServicesSectionComponent],
  imports: [
    CommonModule,
    ContentSectionModule,
    SliderModule,
    CardsModule,
    TranslocoModule,
    RouterModule,
    FontAwesomeModule,
    ButtonModule,
    CardsModule,
  ],
  exports: [ServicesSectionComponent],
})
export class ServicesSectionModule {}
